import { Banner } from "@/components/ui/banner"
import { WarningContentNoChannel } from "@/modules/inbound-wizard/components/ch/contact-information/warning-content-no-channel"

export const NoChannelContent = () => {
  return (
    <Banner type="inline" variant="warning" className="mt-4 gap-2">
      <div className="mt-1">
        <WarningContentNoChannel />
      </div>
    </Banner>
  )
}
